/**
 * Les Parisiennes — Size Guide Module
 */
(function () {
  'use strict';
  var LP = window.LPTheme || {};

  var _euConv = LP.sizeConv || {};
  function convertSize(eu, metric) {
    return LP.convertSize ? LP.convertSize(eu, metric) : ((_euConv[eu] && _euConv[eu][metric]) || eu);
  }

  function registerInit(name, fn) {
    if (LP && typeof LP.registerInit === 'function') LP.registerInit(name, fn);
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ============================================================
   * 25. FIND YOUR SIZE MODAL
   * ============================================================ */
  window.openFindYourSize = function () {
    var modal = document.getElementById('fys-modal');
    var overlay = document.getElementById('fys-overlay');
    if (!modal) return;
    var chartTab = modal.querySelector('[data-tab="chart"]');
    if (chartTab) window.switchFysTab(chartTab);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (LP.activateFocusTrap) LP.activateFocusTrap(modal);
  };

  window.closeFindYourSize = function () {
    var modal = document.getElementById('fys-modal');
    var overlay = document.getElementById('fys-overlay');
    if (modal) { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); }
    if (overlay) overlay.classList.remove('is-open');
    if (modal && LP.deactivateFocusTrap) LP.deactivateFocusTrap(modal);
    document.body.style.overflow = '';
  };

  window.switchFysTab = function (btn) {
    var tab = btn.dataset.tab;
    var modal = document.getElementById('fys-modal');
    if (!modal) return;
    modal.querySelectorAll('.fys-modal__tab').forEach(function (t) {
      var active = t === btn;
      t.classList.toggle('fys-modal__tab--active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      t.setAttribute('tabindex', active ? '0' : '-1');
    });
    modal.querySelectorAll('.fys-modal__panel').forEach(function (p) {
      var active = p.dataset.panel === tab;
      p.classList.toggle('fys-modal__panel--active', active);
      p.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
  };

  /* ============================================================
   * 26. SIZE METRIC TAB SWITCHING
   * ============================================================ */
  window.switchSizeMetric = function (btn) {
    var container = btn.closest('.size-modal__metrics') || btn.closest('.size-metrics');
    if (!container) return;
    var metric = btn.dataset.metric;
    if (['eu', 'us', 'uk'].indexOf(metric) === -1) return;
    container.querySelectorAll('.size-metric-tab').forEach(function (t) { t.classList.remove('size-metric-tab--active'); });
    btn.classList.add('size-metric-tab--active');
    /* Update size-chip elements (inline selector) */
    var selector = container.closest('.size-selector');
    if (selector) {
      selector.querySelectorAll('.size-chip').forEach(function (chip) {
        var euSize = chip.dataset.size;
        chip.textContent = LP.convertSize ? LP.convertSize(euSize, metric) : ((_euConv[euSize] && _euConv[euSize][metric]) ? _euConv[euSize][metric] : euSize);
      });
    }
    /* Update size-modal__item elements (modal) */
    var modal = container.closest('.size-modal');
    if (modal) {
      modal.querySelectorAll('.size-modal__item').forEach(function (item) {
        var euSize = item.dataset.size;
        var sizeSpan = item.querySelector('.size-modal__size');
        if (sizeSpan) sizeSpan.textContent = LP.convertSize ? LP.convertSize(euSize, metric) : ((_euConv[euSize] && _euConv[euSize][metric]) ? _euConv[euSize][metric] : euSize);
      });
    }
    /* Update selected-size label on the product page button if a size is already chosen */
    var selectedItem = document.querySelector('.size-modal__item--selected');
    if (selectedItem) {
      var euSize = selectedItem.dataset.size;
      var sizeLabel = document.getElementById('selected-size-label');
      if (sizeLabel && sizeLabel.textContent) sizeLabel.textContent = LP.getSizeLabel ? LP.getSizeLabel(euSize, metric) : (metric.toUpperCase() + ' ' + convertSize(euSize, metric));
    }
  };

  function initFysChart() {
    var modal = document.getElementById('fys-modal');
    if (!modal || modal.dataset.chartReady === 'true') return;
    modal.dataset.chartReady = 'true';
    var select = modal.querySelector('#fys-size-system');
    var radios = modal.querySelectorAll('input[name="fys-unit"]');
    function updateChart() {
      var system = select && ['eu', 'us', 'uk'].indexOf(select.value) !== -1 ? select.value : 'eu';
      modal.querySelectorAll('[data-fys-converted-size]').forEach(function (cell) {
        cell.textContent = cell.dataset[system] || cell.dataset.eu || '';
      });
      var heading = modal.querySelector('[data-fys-system-heading]');
      if (heading) heading.textContent = system.toUpperCase();
      var inches = false;
      radios.forEach(function (radio) { if (radio.checked) inches = radio.value === 'inches'; });
      modal.querySelectorAll('[data-cm]').forEach(function (cell) {
        var cm = parseFloat(cell.dataset.cm);
        if (Number.isFinite(cm)) cell.textContent = inches ? (cm / 2.54).toFixed(1) : cm.toFixed(1);
      });
      var lengthHeading = modal.querySelector('[data-fys-length-heading]');
      if (lengthHeading) lengthHeading.textContent = lengthHeading.dataset.lengthLabel + (inches ? ' (IN)' : ' (CM)');
    }
    if (select) select.addEventListener('change', updateChart);
    radios.forEach(function (radio) { radio.addEventListener('change', updateChart); });
    var tabs = Array.from(modal.querySelectorAll('.fys-modal__tab'));
    tabs.forEach(function (tab, index) {
      tab.addEventListener('keydown', function (event) {
        var next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        window.switchFysTab(tabs[next]);
        tabs[next].focus();
      });
    });
    updateChart();
  }

  function initPageSizeGuide() {
    document.querySelectorAll('[data-size-guide-controls]').forEach(function (controls) {
      if (controls.dataset.sizeGuideReady === 'true') return;
      var table = controls.parentElement.querySelector('[data-size-guide-table]');
      if (!table) return;
      controls.dataset.sizeGuideReady = 'true';

      controls.querySelectorAll('[data-size-guide-metric]').forEach(function (button) {
        button.addEventListener('click', function () {
          var metric = button.dataset.sizeGuideMetric || 'eu';
          table.dataset.activeMetric = metric;
          controls.querySelectorAll('[data-size-guide-metric]').forEach(function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      });

      controls.querySelectorAll('[data-size-guide-unit]').forEach(function (button) {
        button.addEventListener('click', function () {
          var unit = button.dataset.sizeGuideUnit || 'cm';
          table.querySelectorAll('[data-size-length]').forEach(function (cell) {
            if (cell.tagName === 'TH') {
              var lengthLabel = cell.dataset.lengthLabel || 'Foot length';
              cell.textContent = lengthLabel + ' (' + (unit === 'in' ? 'IN' : 'CM') + ')';
              return;
            }
            var cm = parseFloat(cell.dataset.cm || '');
            if (!Number.isFinite(cm)) return;
            cell.textContent = unit === 'in' ? (cm / 2.54).toFixed(1) : cm.toFixed(1);
          });
          controls.querySelectorAll('[data-size-guide-unit]').forEach(function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      });
    });
  }

  registerInit('initFysChart', initFysChart);
  registerInit('initPageSizeGuide', initPageSizeGuide);
}());
